import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight, MapPin, User, Mail, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function RetailEntryPage() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");

  const canContinue = address.trim().length >= 5;

  const handleNext = () => {
    if (!canContinue) {
      toast.error("Enter the property address first");
      return;
    }
    const params = new URLSearchParams({ name, email, phone, address: address.trim() });
    navigate(`/retail/prepare?${params.toString()}`);
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <div className="sticky top-0 z-10 bg-card border-b border-border/30 px-4 py-3 flex items-center gap-3">
        <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => navigate("/")}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div className="flex-1 min-w-0">
          <h1 className="text-sm font-bold text-foreground truncate">New Retail Quick Quote</h1>
          <p className="text-xs text-muted-foreground truncate">Customer + property → Good/Better/Best in seconds</p>
        </div>
      </div>

      <div className="mx-auto flex-1 w-full max-w-lg space-y-4 px-4 py-6">
        <div className="rounded-xl border border-border/40 bg-card p-4 space-y-3">
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Customer</p>
          <div className="space-y-2.5">
            <div className="relative">
              <User className="absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
              <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Customer name" className="h-10 pl-9 text-sm" />
            </div>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email (optional)" className="h-10 pl-9 text-sm" />
            </div>
            <div className="relative">
              <Phone className="absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
              <Input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone (optional)" className="h-10 pl-9 text-sm" />
            </div>
          </div>
        </div>

        <div className="rounded-xl border border-border/40 bg-card p-4 space-y-3">
          <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Property Address</p>
          <div className="relative">
            <MapPin className="absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
            <Input value={address} onChange={(e) => setAddress(e.target.value)} placeholder="123 Main St, City, State ZIP" className="h-10 pl-9 text-sm" />
          </div>
        </div>

        <Button className="h-14 w-full gap-2 rounded-xl text-base font-bold" disabled={!canContinue} onClick={handleNext}>
          Continue <ArrowRight className="h-5 w-5" />
        </Button>
      </div>
    </div>
  );
}
